import { useRef } from "react";
import { Button, Modal } from "@monolith-forensics/monolith-ui";

import ButtonMenu from "@/components/Forms/components/ButtonMenu";

import { SavedReport } from "../savedReports.types";

interface DeleteSavedReportModalProps {
  show: boolean;
  report: SavedReport | null;
  onClose: () => void;
  onConfirm: (report: SavedReport) => void;
}

export const DeleteSavedReportModal: React.FC<DeleteSavedReportModalProps> = ({
  show,
  report,
  onClose,
  onConfirm,
}) => {
  // Keep the last report so the file name does not blank while the modal
  // animates out after the parent clears it
  const lastReport = useRef(report);
  if (report) lastReport.current = report;
  const shown = report ?? lastReport.current;

  return (
    <Modal open={show} onClose={onClose} style={{ width: "400px" }}>
      <Modal.Title>Delete Saved Report</Modal.Title>
      <div style={{ fontWeight: 500, marginBottom: 10 }}>
        <p>
          Are you sure you want to delete this saved report? This action cannot
          be undone.
        </p>
        <p>
          <span style={{ fontWeight: 600, fontSize: 16 }}>"{shown?.name}"</span>
        </p>
      </div>
      <ButtonMenu>
        <Button size="xs" variant="subtle" onClick={onClose}>
          Cancel
        </Button>
        <Button
          size="xs"
          color="error"
          variant="contained"
          onClick={() => report && onConfirm(report)}
        >
          Delete
        </Button>
      </ButtonMenu>
    </Modal>
  );
};
